import { useContext } from 'react';
import {
	H3,
	Text,
	Label,
	Tile,
	Checkbox,
	Grid,
	Spacer,
	WarnChip
} from '@components';
import { EditShipment } from '@state';
import { useRecoilState } from 'recoil';
import { LOAD_SEC_REQ, getLoadSecReqKey, getLoadingSecurityRequirementLabel } from '@types';
import { EditShipmentContext } from '../EditShipment.Context';

export const AdditionalDetails = () => {
	const ctx = useContext(EditShipmentContext);
	const [shipment, setShipment] = useRecoilState(EditShipment);
	const additionalDetailsAccess = ctx?.access.pages.additionalDetails;
	const updateLoadSecReq = (key: string, checked: boolean) => {
		if (shipment) {
			const cloned = {
				...shipment,
				load_security: {
					...shipment.load_security,
					[key]: checked
				}
			}
			setShipment(cloned);
			if (ctx?.setTouched) ctx.setTouched(true);
		}
	}
	return (
		<>
			<H3>Update Additional Details</H3>
			<Spacer size={16} />
			<Text>Provide extra information such as load restraints.</Text>
			<Spacer size={16} />
			{additionalDetailsAccess?.fields.invoicedWarning.visible && <>
				<WarnChip text={additionalDetailsAccess.fields.invoicedWarning.reason ?? ''} stretch />
				<Spacer size={16} />
			</>}
			<Tile stretch>
				<Label>Load restraints</Label>
				<Spacer size={8} />
				<Grid columns={2} columnTemplate={'repeat(2, 1fr)'} columnGap={'0px'}>
					{Object.values(LOAD_SEC_REQ).map((val, i) => {
						return <Checkbox
							key={i}
							name={''}
							label={getLoadingSecurityRequirementLabel(val)}
							value={getLoadingSecurityRequirementLabel(val)}
							onChange={(e) => updateLoadSecReq(getLoadSecReqKey(val, true), e.target.checked)}
							checked={(shipment?.load_security as unknown as { [key: string]: boolean })?.[getLoadSecReqKey(val, true)]}
							disabled={additionalDetailsAccess?.fields.loadSecurity.disabled ?? false}
						/>
					})}
				</Grid>
			</Tile>
		</>
	);
}
